import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  '/': 'RCCD — A Distinguished Company · Southern California',
  '/who-we-are': 'Who We Are · RCCD',
  '/what-we-do': 'What We Do · RCCD',
  '/what-we-have-done': 'Our Work · Recent Projects · RCCD',
  '/team': 'Meet the Team · RCCD',
  '/contact-us': 'Contact · RCCD',
};

const DESCRIPTIONS = {
  '/': '35+ years of land development across Southern California. $350M+ in equity transactions, 5 adopted specific plans, and Executive Management for the 4,000-acre New Model Colony.',
  '/who-we-are': "A Southern California land partner with 35+ years across land development, large-scale real estate, and homebuilding — current focus on land entitlement.",
  '/what-we-do': "Four practice areas — entitlement, executive management, real estate, and agency coordination — built on relationships across Southern California.",
  '/what-we-have-done': "Recent RCCD projects including Grand Park (330 lots), Falloncrest Chino (203 units), Avenue 229, Esperanza, and the 4,000-acre New Model Colony.",
  '/team': "The senior team leading RCCD's specific-plan, entitlement, and Executive Management work across Southern California.",
  '/contact-us': "Reach RCCD directly — (714) 637-4405 · contact@rccdinc.com · Mon-Fri 8AM-5PM.",
};

export const SEO = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = TITLES[pathname] || 'RCCD — A Distinguished Company';
    const desc = DESCRIPTIONS[pathname] || DESCRIPTIONS['/'];

    document.title = title;

    const setMeta = (selector, attr, value) => {
      const el = document.querySelector(selector);
      if (el) el.setAttribute(attr, value);
    };
    setMeta('meta[name="description"]', 'content', desc);
    setMeta('meta[property="og:title"]', 'content', title);
    setMeta('meta[property="og:description"]', 'content', desc);
    setMeta('meta[property="og:url"]', 'content', `https://www.mmediaclient.com${pathname}`);
    setMeta('meta[name="twitter:title"]', 'content', title);
    setMeta('meta[name="twitter:description"]', 'content', desc);
  }, [pathname]);

  return null;
};
